import { resolvePlanAccess } from "./planEntitlements";

const CLIENT_NAV = [
  { id: "home", to: "/app", end: true, label: "Главная", icon: "overview" },
  { id: "calendar", to: "/app/calendar", label: "Календарь", icon: "schedule" },
  { id: "chat", to: "/app/chat", label: "Чат", icon: "chat", feature: "chat" },
  { id: "life", to: "/app/life", label: "Клуб", icon: "venues", feature: "clubLife" },
  { id: "profile", to: "/app/profile", label: "Профиль", icon: "clients" },
];

const ROUTE_GUARDS = [
  { prefix: "/app/chat", feature: "chat", fallback: "/app" },
  { prefix: "/app/life", feature: "clubLife", fallback: "/app" },
  { prefix: "/app/members", feature: "memberSocial", fallback: "/app/profile" },
];

export function buildClientNav(entitlements, tenant, billing) {
  const plan = resolvePlanAccess(entitlements, tenant, billing);
  return CLIENT_NAV.filter((item) => !item.feature || plan[item.feature]);
}

export function redirectForClientRoute(pathname, entitlements, tenant, billing) {
  const plan = resolvePlanAccess(entitlements, tenant, billing);
  const path = pathname.replace(/\/$/, "") || "/app";
  for (const guard of ROUTE_GUARDS) {
    if (path === guard.prefix || path.startsWith(`${guard.prefix}/`)) {
      if (!plan[guard.feature]) return guard.fallback;
    }
  }
  return null;
}
